/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useGroupStore = defineStore("group", {
  actions: {
    async groupListFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          "name:contains": payload.name,
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/user-svc/group/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async groupInfoFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/user-svc/group/info/" + payload.uid;
          const response = http.get(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async groupAddFetch(payload) {
      const body = {
        code: payload.code,
        name: payload.name,
        domain: payload.domain,
        contactPerson: payload.contactPerson,
        contactNumber: payload.contactNumber,
        contactEmail: payload.contactEmail,
        remark: payload.remark,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/user-svc/group/new";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async groupUpdateFetch(payload) {
      const body = {
        uid: payload.uid,
        code: payload.code,
        name: payload.name,
        domain: payload.domain,
        contactPerson: payload.contactPerson,
        contactNumber: payload.contactNumber,
        contactEmail: payload.contactEmail,
        remark: payload.remark,
        version: payload.version,
        exfunctions: payload.exfunctions,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/user-svc/group/update";
          const response = http.put(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async groupDeleteFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/user-svc/group/delete/" + payload.uid;
          const response = http.delete(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
  },
});
